require("./collapsableMenu/collapsableMenuService");
require("./searchMenu/searchMenuService");

"use strict";

angular.module('app.mainFrame.mainFrameController', [
    'app.mainFrame.collapsableMenu.collapsableMenuService',
    'app.mainFrame.searchMenu.searchMenuService'
])
    .controller('app.mainFrame.mainFrameController', [
        '$scope',
        '$state',
        'app.mainFrame.collapsableMenu.collapsableMenuService',
        'app.mainFrame.searchMenu.searchMenuService',
      /**
       * @param $scope
       * @param {ApplicationStateService} $state
       * @param collapsableMenu
       * @param searchMenu
       */
        function ($scope, $state, collapsableMenu, searchMenu) {
            $scope.state = $state;

            $scope.hideContent = function () {
                return collapsableMenu.menuExpanded || searchMenu.isExpanded;
            };

            $scope.stateTitle = function () {
                if ($state.current.isChildState) {
                    return $state.$current.parent.title;
                }
                else {
                    return $state.current.title;
                }
            }
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/mainFrame/mainFrameController.js